import { render, staticRenderFns } from "./AlSectionHero.vue?vue&type=template&id=3cbe4f8c&"
import script from "./AlSectionHero.vue?vue&type=script&lang=js&"
export * from "./AlSectionHero.vue?vue&type=script&lang=js&"
import style0 from "./AlSectionHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports